export const QUESTION_FULL = 'QUESTION_FULL';
export const QUESTION_TEXT = 'QUESTION_TEXT';
export const QUESTION_RADIO = 'QUESTION_RADIO';

export const QUESTION_TYPES = [
  QUESTION_FULL,
  QUESTION_TEXT,
  QUESTION_RADIO
]

const getType = (q) => {
  switch (true) {
    case q.hasOwnProperty('title') && q.hasOwnProperty('text'):
      return QUESTION_FULL;
    case q.hasOwnProperty('title') && !q.hasOwnProperty('text'):
      return QUESTION_RADIO;
    case !q.hasOwnProperty('title') && q.hasOwnProperty('text'):
      return QUESTION_TEXT;
    default:
      throw Error(`QUESTION ${JSON.stringify(q)} INVALID, |${q.title}|, |${q.text}|, |${!q.title}|, |${!q.text}|, |${q.title && q.text}|`);
  }
}


const QUESTIONS_DATA = [
  {
    id: 'other',
    title: 'Czy miał Pan/Pani inny kredyt związany z walutą obcą?',
    text: 'Kiedy, w jakim Banku i w jakiej walucie'
  },
  {
    id: 'over',
    title: 'Czy kredyt był nadpłacany?',
    text: 'W jakiej kwocie i kiedy?'
  },
  {
    id: 'attachment',
    title: 'Czy zostały podpisane jakiekolwiek aneksy do umowy kredytu?',
  },
  {
    id: 'increase',
    title: 'Czy została zwiększona kwota kredytu?',
    text: 'W jakiej kwocie i kiedy?'
  },
  {
    id: 'paid',
    title: 'Czy kredyt został spłacony wcześniej?',
    text: 'W jakiej kwocie i kiedy?'
  },
  {
    id: 'corporate',
    title: 'Czy w nieruchomości była prowadzona działalność?',
    text: 'O jakim charakterze i od kiedy?'
  },
  {
    id: 'additional',
    text: 'Dodatkowe informacje dla adwokata'
  }
]

export const QUESTIONS = QUESTIONS_DATA.map(q => ({
  ...q,
  type: getType(q)
}))
